import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../store/AppContext";
import "../../../styles/Login.css";

const FormularioLogin = ({ setBienvenida }) => {
	const { store, actions } = useContext(Context);
	const [error, setError] = useState(null);
	const [credentials, setCredentials] = useState({
		email: "",
		password: "",
	});

	useEffect(() => {
		if (store.usuarioActual != null) {
			setBienvenida(true);
		}
	}, [store.usuarioActual, setBienvenida]);

	const iniciarSpinner = () => {
		if (!store.spinner) {
			actions.setSpinner();
		}
	};

	const HandlerLoginGoogle = async () => {
		setError(null);
		iniciarSpinner();
		const result = await actions.loginFirebase();
		if (!result.success) {
			setError(result.error);
		}
	};

	const handleEmailPasswordLogin = async (e) => {
		e.preventDefault();
		setError(null);
		iniciarSpinner();

		const result = await actions.loginFirebaseEmail(
			credentials.email,
			credentials.password
		);

		if (!result.success) {
			setError(result.error);
		}
	};

	const handleInputChange = (e) => {
		setCredentials({
			...credentials,
			[e.target.name]: e.target.value,
		});
	};

	const ocupado = Boolean(store.spinner);

	return (
		<div className='log-in-form'>
			<h4 className='text-center'>Ingresa con tu Cuenta de DeNegocios.cl</h4>

			{error && <div className='login-error text-center'>{error}</div>}

			<div className='text-center'>
				<button
					className='google-login-btn'
					onClick={HandlerLoginGoogle}
					disabled={ocupado}
					type='button'
				>
					<img
						src='https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg'
						alt=''
					/>
					Iniciar sesión con Google
				</button>
			</div>

			<div className='login-form-section'>
				<h5 className='text-center'>O ingresa con tu correo y clave</h5>
				<form onSubmit={handleEmailPasswordLogin}>
					<div className='grid-x grid-padding-x'>
						<div className='cell'>
							<input
								type='email'
								name='email'
								placeholder='Correo electrónico'
								value={credentials.email}
								onChange={handleInputChange}
								disabled={ocupado}
								required
							/>
						</div>
						<div className='cell'>
							<input
								type='password'
								name='password'
								placeholder='Contraseña'
								value={credentials.password}
								onChange={handleInputChange}
								disabled={ocupado}
								required
							/>
						</div>
						<div className='cell'>
							<button
								type='submit'
								className='button expanded login-submit-btn'
								disabled={ocupado}
							>
								Iniciar sesión
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};

export default FormularioLogin;
